import { Box, Button, Grid, InputAdornment, TextField } from '@mui/material';
import { Add, SearchOutlined } from '@mui/icons-material';
import { DepartmentFilter } from '../../model/department.model';

interface IProps {
  filter: DepartmentFilter | null;
  onFilterChange: (filter?: DepartmentFilter | null) => void;
  handleOpenDialog: () => void;
}

const DepartmentHeader = ({ filter, onFilterChange, handleOpenDialog }: IProps) => {
  return (
    <Box sx={{ py: 3, px: 3 }}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} md={3}>
          <TextField
            value={filter?.search ?? ''}
            onChange={(e) => {
              if (e.target.value.trim()) {
                onFilterChange({ ...filter, search: e.target.value, skip: 0 });
              } else {
                const updated = { ...filter };
                delete updated.search;
                onFilterChange(updated);
              }
            }}
            size="small"
            placeholder="ຄົ້ນຫາກົມ"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined />
                </InputAdornment>
              ),
              style: { borderRadius: '30px' },
            }}
            fullWidth
          />
        </Grid>
        <Box flex={1} />
        <Grid
          item
          xs={12}
          md={3}
          sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}
        >
          <Button
            variant="contained"
            sx={{ width: { md: '84%', xs: '100%' }, borderRadius: 5 }}
            onClick={handleOpenDialog}
            fullWidth
          >
            <Add /> ເພີ່ມກົມ
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DepartmentHeader;
